module.exports = __webpack_public_path__ + "img/东海底层鱼渔情预报系统.3a2a3e32.png";